import React from 'react';
import PropTypes from 'prop-types';
import Svg from 'react-inlinesvg';
import { Breakpoints } from '../../../utils';
import { download2Icon } from '../../../images';
import { useMediaQuery } from 'react-responsive';
// `FileName` expected
const DownloadCell = ({ cell, ...rest }) => {
  const { FileName } = rest.row.original;

  const isMobile = useMediaQuery({
    maxWidth: Breakpoints.computerBreakpoint - 1
  });
  const isDesktop = useMediaQuery({ minWidth: Breakpoints.computerBreakpoint });
  return (
    <a
      href={cell.value}
      download
      aria-label="link download to asset"
      data-test={`${FileName}-download`}
    >
      {isMobile && (
        <Svg
          src={download2Icon}
          accessibilityLabel="Download Icon"
          accessibilityDesc="Download for downloading the appropriate asset"
        />
      )}

      {isDesktop && (
        <small className="link--boxed table__item--hidden">DOWNLOAD</small>
      )}
    </a>
  );
};

DownloadCell.propTypes = {
  isCell: PropTypes.bool,
  cell: PropTypes.object
};
export default DownloadCell;
